import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';

/**
 * /payment-methods.
 *
 * The template had the list inside the paragraph that introduces it, which no browser
 * ever rendered that way — a `<ul>` closes an open `<p>`. They are siblings here, which
 * is what the page has always shown.
 */
export default function ValidPaymentMethods() {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Valid Payment Methods' }]} />

      <PageHeading eyebrow="Customer Information">Valid Payment Methods</PageHeading>

      <div className="prose mt-6 flex flex-col gap-6">
        <ContentCard>
          <p>For your convenience, DiscountMags.com accepts the following payment methods:</p>
          <ul>
            <li>Visa</li>
            <li>Discover</li>
            <li>MasterCard</li>
            <li>American Express</li>
            <li>PayPal</li>
            <li>Apple Pay</li>
            <li>Pay with Google</li>
          </ul>
        </ContentCard>
      </div>
    </>
  );
}

ValidPaymentMethods.layoutName = 'Layouts.Institutional';
